import Map from '../components/map/Index.vue';
import CarrierServiceableLoad from '../components/map/CarrierServiceableLoad.vue';

export default [
	{
		path: '/map',
		name: 'Map',
		component: Map,
		meta: {
			requiresAuth: true,
			permissions: {
				ServiceMap: ['View Service Map']
			}
		}
	},
	{
		path: '/carrier-serviceable-load',
		name: 'CarrierServiceableLoad',
		component: CarrierServiceableLoad,
		meta: {
			requiresAuth: true,
			permissions: {
				ServiceMap: ['Edit Service Map']
			}
		}
	}
]



// WEBPACK FOOTER //
// ./src/router/MapRoutes.js